// Dados oficiais da pessoa jurídica controladora do Amuzze.
// Fonte: comprovante CNPJ da Receita Federal (emissão 28/05/2026).
// Atualizar aqui caso mudança de razão social, sede, sócios ou natureza.

export const COMPANY = {
  razaoSocial:    'Amuzze Tecnologia Ltda',
  nomeFantasia:   'Amuzze',
  cnpj:           '67.050.083/0001-02',
  endereco:       'Rua Buarque de Macedo, 1057, apt. 31, Edifício Portal da Lagoa, Jardim Brasil, Campinas/SP — CEP 13073-010',
  // Endereço apenas para correspondência (Cloudflare Routing, Play/ASC,
  // formulários de contato públicos, rodapé site). NUNCA usar em documentos
  // oficiais que digam "com sede em" — INPI/ANPD/Receita comparam com o
  // cadastro CNPJ, e sede legal é `endereco` acima. Regra registrada em
  // memory `project_amuzze_dados_pj_completos` após bug D.6 INPI 16/ago/26.
  // ⚠️ CEP corrigido 12/09/2026: estava `13976-970`, que **não existe** —
  // conferido na base dos Correios (ViaCEP devolve `erro` para ele). O valor
  // certo é o que os documentos jurídicos já usavam em 6 lugares (Termos v2.4,
  // Privacidade v3.5, DPO v1.2): `13076-970`, Campinas/SP.
  // Lição: quando o dado diverge entre o painel e os documentos assinados,
  // os documentos ganham — e, mesmo assim, vale conferir os dois na fonte.
  caixaPostal:    'Caixa Postal 7003, Campinas/SP — CEP 13076-970',
  email:          'contato@amuzze.com.br',
  dpo:            'Pablo Rodrigo Sousa Nascimento',
  dpoEmail:       'privacidade@amuzze.com.br',
  natureza:       'Sociedade Empresária Limitada (Ltda)',
  porte:          'ME (Microempresa)',
  cnaePrincipal:  '62.03-1-00 — Desenvolvimento e licenciamento de programas de computador não-customizáveis',
  dataAbertura:   '28/05/2026',
} as const;
